import { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { initFacebookPixel } from '../facebookPixel';
import './SuccessPage.css';

const SuccessPage = () => {
  const [message, setMessage] = useState('');
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const paymentStatus = sessionStorage.getItem('paymentStatus');
    const savedMessage = sessionStorage.getItem('message');

    if (paymentStatus === 'success') {
      setMessage(savedMessage || 'Thank you for your payment!');
    }

    sessionStorage.removeItem('paymentStatus');
    sessionStorage.removeItem('message');

    // Delay animation slightly
    setTimeout(() => setAnimate(true), 100);

    initFacebookPixel();
  }, []);

  const handleConfirm = () => {
    window.location.href = '/';
  };

  const handleContactSupport = () => {
    window.open('https://wa.me/+919663979929?text=Hello%20Machaxi', '_blank');
    window.location.href = '/';
  };

  return (
    <div className={`success-page-container ${animate ? 'fade-in' : ''}`}>
      <div className="success-card pulse-effect">
        {/* Header with success icon */}
        <div className="success-header">
          <div className="icon-container check-icon">
            <CheckCircle size={48} className="text-green-500" />
          </div>
        </div>

        {/* Body content */}
        <div className="success-content">
          <h1 className="success-title">Success!</h1>
          <div className="message-container">
            <p className="success-message">{message}</p>
          </div>

          <div className="actions-container">
            <button className="button button-primary" onClick={handleConfirm}>
              Return to Home
            </button>
            <button className="button button-support" onClick={handleContactSupport}>
              Contact Support
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
